import { Popover, Flex, Button } from "antd";

const StockCode = ({ value }) => {
  const openNewTab = (stock) => {
    const host = window.location.host;
    const url = `${window.location.protocol}//${host}/finance-infor/${stock}`;
    window.open(url, "_blank");
  };

  const content = (
    <Flex vertical align="start">
      <Button style={{ fontWeight: "600" }} type="text" onClick={() => openNewTab(value)}>
        Thông tin Tài Chính
      </Button>
      {/* <Button style={{ fontWeight: "600" }} type="text" onClick={() => openNewTab(value)}>
        Thêm vào danh sách Theo Dõi
      </Button>
      <Button style={{ fontWeight: "600" }} type="text" onClick={() => openNewTab(value)}>
        Thêm vào danh sách Nắm Giữ
      </Button> */}
    </Flex>
  );

  return (
    <Popover content={content} trigger="click" placement="bottomLeft">
      <b
        style={{
          cursor: "pointer",
          color: "#015096",
          fontSize: "1.1rem",
        }}>
        {value}
      </b>
    </Popover>
  );
};

export default StockCode;
